import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { changePassword } from 'src/app/model/user.model';
import { MessageUtil } from 'src/app/helpers/messages';
import { MustMatch } from 'src/app/helpers/match-helper';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {
  passwordForm: FormGroup;
  passwordLoading: boolean;
  passwordError: string;
  passwordPayload = new changePassword
  errorMsg: boolean;

  constructor(private app: AppService, private fb:FormBuilder,) { }

  ngOnInit(): void {   
    this.passwordForm = this.fb.group({  
      'oldpassword': ['', Validators.required],
      'newpassword': ['', Validators.required],
      'confirmpassword': ['', Validators.required],
   },{
    validator: MustMatch('newpassword', 'confirmpassword')
  })
  }

  changePassword(){
    let form = this.passwordForm
    this.passwordError = ''
    this.errorMsg = false
    this.passwordLoading = true

    this.passwordPayload.password = form.get('oldpassword').value.trim()
    this.passwordPayload.newpassword = form.get('newpassword').value.trim()
    this.passwordPayload.username = this.app.helperService.getUsername()

    this.app.userService.changePassword(this.passwordPayload)
    .subscribe(res => {
      if (res['message'] == MessageUtil.RESPONSE_SUCCESS) {
        this.errorMsg = false
        this.passwordError = ''
        this.passwordLoading = false
        this.app.snackBar.open('Operation Successful', 'Dismiss', {
          duration:MessageUtil.TIMEOUT_DURATION
        }) 
      }
              
      else {
        this.errorMsg = true
        this.passwordLoading = false
        this.passwordError = res['data']
      }
    }, err => {
      this.errorMsg = true
      this.passwordLoading = false
      this.passwordError = MessageUtil.INTERNAL_SERVER_ERROR      
    })

    
  }

}
